export const appConfig = {
    logoutURL: "https://www.vexels.com/profile",
    loginURL: "https://www.vexels.com/login",
    maxEvents: 8
} 